import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const fullPath = process.env.PUBLIC_URL + pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    // Special handling for related routes - using pathname without PUBLIC_URL
    const routeGroups = {
      '/batch-details': ['/bag-list', '/bag-details', '/batch-details']
    };

    // First check if current path matches any route group
    for (const [menuPath, relatedPaths] of Object.entries(routeGroups)) {
      for (const relatedPath of relatedPaths) {
        if (pathName === relatedPath || pathName.startsWith(relatedPath + '/')) {
          // Find the menu item with this path
          for (let i = 0; i < items.length; ++i) {
            const itemPath = items[i].pathname.replace(process.env.PUBLIC_URL, '');
            if (itemPath === menuPath) {
              matchingMenuItem = items[i];
              break;
            }
          }
          if (matchingMenuItem) break;
        }
      }
      if (matchingMenuItem) break;
    }

    // If no route group match, check for exact match
    if (!matchingMenuItem) {
      for (let i = 0; i < items.length; ++i) {
        if (fullPath === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
    }

    // If still no match, check if current path starts with any menu item path
    if (!matchingMenuItem) {
      for (let i = 0; i < items.length; ++i) {
        const itemPath = items[i].pathname;

        // Skip the root path and hash links
        if (itemPath && itemPath !== '/' && !itemPath.includes('#')) {
          if (fullPath.startsWith(itemPath)) {
            matchingMenuItem = items[i];
            break;
          }
        }
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

 const isAdmin = sessionStorage.getItem("role") === "admin" ? true : false;


  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            {/* <li>
              <Link to="/scan-qr-code" className="waves-effect">
                <i className="mdi mdi-qrcode"></i>

                <span>{props.t("Scan QR Code")}</span>
              </Link>
            </li>

            <li>
              <Link to="/batch-details" className=" waves-effect">
                <i className="ti-bag"></i>

                <span>Batch Details</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-settings"></i>
                <span>{props.t("Process Management")}</span>
              </Link>
              <ul className="sub-menu" >
                <li>
                  <Link to="/process-master">{props.t("Process Master")} </Link>
                </li>
                <li>
                  <Link to="/process-sequence">{props.t("Process Sequence")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/reports" className=" waves-effect">
                <i class="ti-agenda"></i>

                <span>Reports</span>
              </Link>
            </li>
            <li>
              <Link to="/due-today" className=" waves-effect">
                <i class="ti-time"></i>

                <span>Due Today</span>
              </Link>
            </li>

            <li>
              <Link to="/output" className=" waves-effect">
                <i class="ti-package"></i>

                <span>Output</span>
              </Link>
            </li>
            <li>
              <Link to="/farm-master" className=" waves-effect">
                <i class="fa-seedling"></i>

                <span>Farm Master</span>
              </Link>
            </li> */}
            <li>
              <Link to={isAdmin ? "/admin/scan-qr-code" : "/scan-qr-code"} className="waves-effect">
                <i className="mdi mdi-qrcode"></i>
                <span>{props.t("Scan QR Code")}</span>
              </Link>
            </li>

            <li>
              <Link to={isAdmin ? "/admin/batch-details" : "/batch-details"} className="waves-effect">
                <i className="ti-bag"></i>
                <span>Batch Details</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-settings"></i>
                <span>{props.t("Process Management")}</span>

              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to={isAdmin ? "/admin/process-master" : "/process-master"}>
                    {props.t("Process Master")}
                  </Link>
                </li>

                <li>
                  <Link to={isAdmin ? "/admin/process-sequence" : "/process-sequence"}>
                    {props.t("Process Sequence")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to={isAdmin ? "/admin/reports" : "/reports"} className="waves-effect">
                <i className="ti-agenda"></i>
                <span>Reports</span>
              </Link>
            </li>

            <li>
              <Link to={isAdmin ? "/admin/due-today" : "/due-today"} className="waves-effect">
                <i className="ti-time"></i>
                <span>Due Today</span>
              </Link>
            </li>

            <li>
              <Link to={isAdmin ? "/admin/output" : "/output"} className="waves-effect">
                <i className="ti-package"></i>
                <span>Harvest</span>
              </Link>
            </li>

            {isAdmin && (
              <li>
                <Link to="/admin/farm-master" className="waves-effect">
                  <i className="fa-seedling"></i>
                  <span>Farm Master</span>
                </Link>
              </li>
            )}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))